import { useReactiveVar } from "@apollo/client";

import ChatHistoryList from "@apps/home/components/chat-history-list";
import { leftSidePanelVar } from "@cache/cache";

const SidebarChatsExpanded = () => {
  const leftSidePanel = useReactiveVar(leftSidePanelVar);
  const chatsPanelOpen = leftSidePanel === "chats";

  if (!chatsPanelOpen) {
    return null;
  }

  // No onClickChatSessionId: let the links navigate normally to /ask-ai/:id.
  // The layout's route-change effect closes the mobile sidebar on navigation.
  return (
    <div className="bg-sidenav-back flex-1 flex flex-col overflow-hidden border-gray-200">
      <ChatHistoryList className="flex-1 px-3 py-4 overflow-y-auto scrollbar-hidden" />
    </div>
  );
};

export default SidebarChatsExpanded;
